module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0056.jpg?v=282dadee";